<div *ngIf="cfg.env && cfg.env.toLowerCase() !== 'productie'"
     [ngClass]="'env-banner ' + cfg.env.toLowerCase()">
  {{ cfg.env.toUpperCase() }} OMGEVING
</div>

<div class="nav-container"
     [class.has-banner]="cfg.env && cfg.env.toLowerCase() !== 'productie'">

  <a routerLink="/">
    <img alt="AxionContinu logo" height="40" ngSrc="./assets/img/axion-logo.svg" width="40"/>
    <span>NextView</span>
  </a>
  <ul>
    <ng-container *ngFor="let reportGroup of reportGroups; index as i">
      <app-nav-item
        (click)="reportGroupMenu.toggle($event)"
        [isActive]="reportGroup.isActive"
        [isReportGroup]="true"
        [text]="reportGroup.name"
        icon="pi pi-folder"/>
      <p-menu #reportGroupMenu [model]="reportGroupMenuItems[i]" [popup]="true" styleClass="nav-dropdown"/>
    </ng-container>
  </ul>
  <ul class="right-menu">
    <app-nav-item (click)="adminMenu.toggle($event)" *ngIf="isAdmin()" icon="pi pi-cog" text="Administratie"/>
    <app-nav-item (click)="userMenu.toggle($event)" [text]="currentUser?.fullName ?? 'Onbekend'"
                  icon="pi pi-user"></app-nav-item>
  </ul>

  <p-progressBar
    *ngIf="isLoading"
    [@inOutAnimation]
    [style]="{ height: '5px' }"
    class="progress-bar"
    mode="indeterminate">
  </p-progressBar>
</div>
<p-menu #adminMenu [model]="adminMenuItems" [popup]="true" styleClass="nav-dropdown"/>
<p-menu #userMenu [model]="userMenuItems" [popup]="true" styleClass="nav-dropdown">
  <ng-template pTemplate="start">
    <div class="menu-header">
      <img alt="AxionContinu logo" height="40" ngSrc="./assets/img/axion-logo-inversed.svg" width="40"/>
      <strong>NextView</strong>
      <span>Reporting Portal</span>
      <small *ngIf="cfg.env">{{ cfg.env }}</small>
      <small>v{{ cfg.version }}</small>
    </div>
  </ng-template>
</p-menu>
